import { useTranslation } from 'react-i18next';
import ExoDialog from '../../exo/ExoDialog';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useEffect, useState } from 'react';
import ExoTable from '../../exo/ExoTable';
import MoneyLabel from '../../label/MoneyLabel';
import ExoTableRecipient from '../../exo/ExoTableRecipient';
import DateLabel from '../../label/DateLabel';
import { InvoiceStatus } from '../../special/Status';
import { DBRequest, useConfig } from '../../../api/api';
import Loader from '../../special/Loader';

export const AddInvoice = ({
  open,
  onClose,
  onSelect,
  recipientId,
  recipientType,
  existingInvoices,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [apiData, setApiData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [currentView, setCurrentView] = useState('same');

  useEffect(() => {
    handleLoadView(currentView);
  }, [config]);

  function handleLoadView(view) {
    const path =
      view === 'same' && recipientId && recipientType
        ? `invoices?recipientType[eq]=${recipientType}&recipientId[eq]=${recipientId}`
        : 'invoices';
    DBRequest({ config, path: path, onResponse: handleIndexRes });
  }

  function handleIndexRes(res) {
    setApiData(res);
  }

  function handleViewChange(e, value) {
    if (value && value !== currentView) {
      handleLoadView(value);
      setCurrentView(value);
    }
  }

  function handleShowRequest(inv) {
    DBRequest({
      config,
      path: `invoices/${inv.id}`,
      onResponse: handleSelectedRes,
      onLoading: setIsLoading,
    });
  }

  function handleSelectedRes(res) {
    onClose();
    onSelect(res.data);
  }

  // const [searchResults, setSearchResults] = useState(null);

  // table
  const columns = [
    {
      header: t('Nr'), // header of column
      key: 'nr', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      cell: ({ row }) => (
        <Box className="monospace whitespace-nowrap">{row.nr}</Box>
      ), // custom xml for cells in the column. you get the row as object
      onClick: (row) => handleShowRequest(row),
    },
    {
      header: t('Status'),
      key: 'status',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      cell: ({ row }) => <InvoiceStatus number={row.status} />, // custom xml for cells in the column. you get the row as object
      onClick: (row) => handleShowRequest(row),
    },
    {
      header: t('Date'),
      key: 'date',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      hiddenMobile: true,
      cell: ({ row }) => <DateLabel date={row.date} />,
      onClick: (row) => handleShowRequest(row),
    },
    {
      header: t('Title'),
      key: 'title',
      width: '100%',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      hiddenMobile: true,
      onClick: (row) => handleShowRequest(row),
    },
    {
      header: t('Client'),
      key: 'recipient',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      width: '270px',
      sortable: true, // enable sort function for column
      hiddenMobile: true,
      cell: ({ row }) => <ExoTableRecipient row={row} />, // custom xml for cells in the column. you get the row as object
      onClick: (row) => handleShowRequest(row),
    },
    {
      header: t('Sum'),
      key: 'amount',
      thAlign: 'right', // header text alignment
      tdAlign: 'right', // cell text alignment
      className: 'w-full lg:w-auto',
      cell: ({ row }) => <MoneyLabel money={row.amount} />,
      sortable: true, // enable sort function for column
      onClick: (row) => handleShowRequest(row),
    },
  ];

  function checkIfItsSelected(row) {
    if (!existingInvoices) return false;
    var isSelected = false;
    existingInvoices?.forEach((element) => {
      if (element.id === row.id) return (isSelected = true);
    });
    return isSelected;
  }
  return (
    <ExoDialog open={open} onClose={onClose}>
      <Box className="w-full h-full flex flex-col gap-2">
        {recipientId && recipientType && (
          <ToggleButtonGroup
            size="small"
            value={currentView}
            exclusive
            onChange={handleViewChange}
            aria-label="Status"
          >
            <ToggleButton value="same">{t('Same receiver')}</ToggleButton>
            <ToggleButton value="all">{t('all')}</ToggleButton>
          </ToggleButtonGroup>
        )}
        {/* <DBSearch param={'invoices'} onSearch={setSearchResults}> */}
        <ExoTable
          columns={columns}
          noBackground
          data={apiData}
          isLoading={!Boolean(apiData)}
          isSelectedElement={checkIfItsSelected}
        />
        {/* </DBSearch> */}
      </Box>
      <Loader active={isLoading} />
    </ExoDialog>
  );
};
